import { BaseThunk } from 'components/base/base-thunk';
import moment from 'moment';
import { ALl_STATUS, FORMAT_DATETIME } from 'utils/constants';
import { RootState } from 'store';
import { InstallationTaskService } from '../installation.services';

const installationTaskService = new InstallationTaskService();

const installationTaskThunkManager = new BaseThunk<
    InstallationTable,
    IInstallationTaskUpdateReq,
    IInstallationTaskUpdateReq
>(installationTaskService);

export const getAllInstallationTasksThunk = installationTaskThunkManager.getAll<
    ResponseBase<InstallationTable[]>,
    InstallationSearch | undefined
>('installationTask/getAll', (params, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const installationTaskState = state.installTask;
    const paginateMetaData = installationTaskState.paginateMetaData;

    const isValidValue = (value: any) => value !== null && value !== undefined && value !== '';
    const isDateKey = (key: string) => ['planned_date_from', 'planned_date_to'].includes(key);

    const formatDateValue = (value: any) => moment.utc(value).format(FORMAT_DATETIME.YYYYMMDD2);

    const filter = params
        ? Object.entries(params).reduce<InstallationSearch>((acc, [key, value]) => {
              if (key === 'status' && value) {
                  acc[key] = [value.toString()];
              } else if (isValidValue(value) || key === 'delete_at') {
                  acc[key as keyof InstallationSearch] = isDateKey(key)
                      ? formatDateValue(value)
                      : value;
              }
              return acc;
          }, {})
        : {};

    const hasOtherKeys = Object.keys(filter).some((key) => key !== 'delete_at');
    const hasStatus = 'status' in filter;

    if (hasOtherKeys && !hasStatus) {
        filter.status = ALl_STATUS;
    } else if (!filter.hasOwnProperty('status')) {
        filter.status = ['1'];
    }

    if (
        filter.status &&
        Array.isArray(filter.status) &&
        filter.status.length === 1 &&
        filter.status[0].includes(',')
    ) {
        filter.status = filter.status[0].split(',');
    }

    const request: InstallationListRequestJson = {
        page: paginateMetaData.page,
        per_page: paginateMetaData.per_page,
        filter: JSON.stringify(filter),
    };

    if (installationTaskState?.sort) {
        request.sort = installationTaskState.sort;
    }

    return request;
});
